// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BackwardFilledSvg from "@ant-design/icons-svg/es/asn/BackwardFilled";
import AntdIcon from '../components/AntdIcon';

var BackwardFilled = function BackwardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BackwardFilledSvg
  }));
};

BackwardFilled.displayName = 'BackwardFilled';
export default React.forwardRef(BackwardFilled);